<a darkShadow [routerLink]="url" [queryParams]="queryParams"
   class="flex items-center gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 transition-all cursor-pointer">
    <mat-icon [svgIcon]="icon" class="icon-size-6 text-primary-600 dark:text-primary-400"></mat-icon>
    <div class="flex-1 min-w-0">
        <h4 class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ title }}</h4>
        <p *ngIf="description" class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ description }}</p>
    </div>
    <span *ngIf="badge" class="flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-full bg-red-500 text-white text-xs font-bold mr-1">{{ badge }}</span>
    <mat-icon svgIcon="tabler_outline:chevron-right" class="icon-size-4 text-gray-400"></mat-icon>
</a>
